import CustomTextArea from './customTextArea';

export default CustomTextArea;